export default "__VITE_ASSET__Dd73Eegj__"